var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-forms" },
    [
      _c(
        "h2",
        { staticClass: "activity-forms__title typographies-heading-h2" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t.__("common.labels.activity")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "activity-forms__actions" },
        [
          _vm.getFormById("email")
            ? _c("ActivityButton", {
                attrs: {
                  object: "sent-email",
                  label: _vm.getFormById("email").label,
                  dataBot: _vm.getFormById("email").databot
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick("email")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getFormById("phonecall_scheduled") && _vm.getFormById("phonecall")
            ? _c("ActivitySplitButton", {
                attrs: {
                  object: "phone",
                  label: _vm.getFormById("phonecall_scheduled").label,
                  dataBot: _vm.getFormById("phonecall_scheduled").databot,
                  menuItems: [
                    {
                      label: _vm.getFormById("phonecall").label,
                      dataBot: _vm.getFormById("phonecall").databot,
                      action: function() {
                        return _vm.handleClick("phonecall")
                      }
                    }
                  ]
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick("phonecall_scheduled")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getFormById("task")
            ? _c("ActivityButton", {
                attrs: {
                  object: "task",
                  label: _vm.getFormById("task").label,
                  dataBot: _vm.getFormById("task").databot
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick("task")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getFormById("event")
            ? _c("ActivityButton", {
                attrs: {
                  object: "calendar",
                  label: _vm.getFormById("event").label,
                  dataBot: _vm.getFormById("event").databot
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick("event")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass:
            "activity-forms__subtitle typographies-paragraph-medium-semibold"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t.__("common.labels.toComment")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("AnnotationForm", {
        attrs: {
          isLoading: _vm.loading,
          linkedtype: _vm.linkedtype,
          linkedid: _vm.linkedid,
          data: _vm.tmpForm.data
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }